module.exports = __webpack_public_path__ + "img/home_1920.d047ace1.webp";